import React from "react";
import { CardMedia } from "@mui/material";
import logo from "../imgs/logo.png";

const Loading = () => (
  <div className="loading-container">
    <CardMedia
      className="loading-img"
      alt="Cargando..."
      component="img"
      image={logo}
    />
  </div>
);

export default Loading;
